import styled from 'styled-components';

export const FormRow = styled.div`
  margin: 12px 0;
`;
